import React, { useState } from "react";
import "./Mraiseticket.css";

export default function RaiseTicket() {
  const [tickets, setTickets] = useState([]);
  const [formData, setFormData] = useState({
    department: "",
    description: "",
    remarks: "",
    feedback: "",
    comments: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newTicket = {
      id: `TCK-${Math.floor(1000 + Math.random() * 9000)}`,
      department: formData.department,
      description: formData.description,
      status: "Open",
      remarks: formData.remarks,
      feedback: formData.feedback,
      comments: formData.comments,
    };

    setTickets([...tickets, newTicket]);

    setFormData({
      department: "",
      description: "",
      remarks: "",
      feedback: "",
      comments: "",
    });
  };

  return (
    <div className="rt-wrapper">
      <h2 className="rt-title">Raise Ticket</h2>

      {/* FORM */}
      <form className="rt-form" onSubmit={handleSubmit}>
        <div className="rt-grid">
          <select
            name="department"
            value={formData.department}
            onChange={handleChange}
            required
          >
            <option value="">Select Department</option>
            <option value="HR">HR</option>
            <option value="IT">IT</option>
            <option value="Finance">Finance</option>
            <option value="Admin">Admin</option>
          </select>

          <input
            type="text"
            name="remarks"
            placeholder="Remarks"
            value={formData.remarks}
            onChange={handleChange}
          />

          <input
            type="text"
            name="feedback"
            placeholder="User Feedback"
            value={formData.feedback}
            onChange={handleChange}
          />

          <input
            type="text"
            name="comments"
            placeholder="User Comments"
            value={formData.comments}
            onChange={handleChange}
          />
        </div>

        <textarea
          name="description"
          placeholder="Description Of The Issue"
          value={formData.description}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit" className="rt-btn">
          Raise Ticket
        </button>
      </form>

      {/* TABLE */}
      <div className="rt-table-wrapper">
        <table className="rt-table">
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>To Department</th>
              <th>Description Of The Issue</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>User Feedback</th>
              <th>User Comments</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr>
                <td colSpan="7" className="rt-empty">
                  No tickets raised yet
                </td>
              </tr>
            ) : (
              tickets.map((ticket, index) => (
                <tr key={index}>
                  <td>{ticket.id}</td>
                  <td>{ticket.department}</td>
                  <td>{ticket.description}</td>
                  <td>
                    <span className="rt-status">{ticket.status}</span>
                  </td>
                  <td>{ticket.remarks}</td>
                  <td>{ticket.feedback}</td>
                  <td>{ticket.comments}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
